import React, { useCallback } from 'react';
import CommonCheckbox from '../../common-checkbox/CommonCheckbox';

const ThCheckbox = ({ selected, onSelect, disabled }) => {
  const toggleAll = useCallback(() => {
    onSelect();
  }, [onSelect]);

  return (
    <div className='th cell-btn'>
      <CommonCheckbox checked={selected} onChange={toggleAll} disabled={disabled}/>
    </div>
  );
};

export default ThCheckbox;
